import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import { DigisubservicesService } from '../services/digisubservices.service';
import { SaveAssignRepresentativeDistributerDailogComponent1Component } from '../pages/save-assign-representative-distributer-dailog-component1/save-assign-representative-distributer-dailog-component1.component';

@Component({
  selector: 'app-book-seller-hand-delivery',
  templateUrl: './book-seller-hand-delivery.component.html',
  styleUrls: ['./book-seller-hand-delivery.component.scss']
})
export class BookSellerHandDeliveryComponent implements OnInit {

  today = '';

  combinedList: any[] = [];

  totalNormal = 0;
  totalSponsor = 0;
  totalComplimentary = 0;
  totalJyda = 0;
  grandTotal = 0;

  masterSelected = false;

  storageKey = 'jyda_store';

  bookwise: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.today = formatDate(new Date(), 'dd/MM/yyyy', 'en-IN');

    // bookName now comes directly from dialog data (passed from parent's handDelivery())
    this.bookwise = this.data?.bookwise || 'All Books';

    this.bindData();
  }

  bindData(): void {

    const store = JSON.parse(
      localStorage.getItem(this.storageKey) || '{}'
    );

    this.combinedList = (this.data.reportData || []).map((x: any) => {

      const key = `${x.DistributiveRep}_${x.district}_${x.taluka} 
       
        : 'अनिर्धारित';`;

      const jyda = Number(store[key] || 0);

      return {
        ...x,
        selected: false,
        jyda: jyda,
        row_total: Number(x.total_book_copies || 0) + jyda
      };
    });

    this.calculateTotals();
  }

  getKey(item: any): string {
    return `${item.DistributiveRep}_${item.district}_${item.taluka}`;
  }

  onJydaChange(item: any): void {

    item.row_total =
      Number(item.total_book_copies || 0) +
      Number(item.jyda || 0);

    this.updateLocalStorage(item);
    this.calculateTotals();
  }

  updateLocalStorage(item: any): void {

    const store = JSON.parse(
      localStorage.getItem(this.storageKey) || '{}'
    );

    store[this.getKey(item)] = Number(item.jyda || 0);

    localStorage.setItem(this.storageKey, JSON.stringify(store));
  }

  calculateTotals(): void {

    this.totalNormal = 0;
    this.totalSponsor = 0;
    this.totalComplimentary = 0;
    this.totalJyda = 0;
    this.grandTotal = 0;

    this.combinedList.forEach(item => {

      this.totalNormal += Number(item.normal_copies || 0);
      this.totalSponsor += Number(item.sponsor_copies || 0);
      this.totalComplimentary += Number(item.complimentary_copies || 0);
      this.totalJyda += Number(item.jyda || 0);
      this.grandTotal += Number(item.row_total || 0);
    });
  }

  checkboxChanged(): void {

    this.masterSelected =
      this.combinedList.length > 0 &&
      this.combinedList.every(x => x.selected);
  }

  checkUncheckAll(): void {

    this.combinedList.forEach(x => x.selected = this.masterSelected);
  }

  openSaveDialog(item: any): void {

    const dialogRef = this.dialog.open(
      SaveAssignRepresentativeDistributerDailogComponent1Component,
      {
        width: '700px',
        data: {
          issueSellerName: item.DistributiveRep,
          dis_mode: item.DistributionMode,
          dis_sub_mode: item.SubDistMode,
          objectData: item
        }
      }
    );

    dialogRef.afterClosed().subscribe((result: any) => {

      if (!result) return;

      item.DistributionMode = result.dis_mode;
      item.SubDistMode = result.dis_sub_mode;
    });
  }

  saveData(): void {

    const payload = this.combinedList.map(item => ({
      distributive_rep: item.DistributiveRep,
      district: item.district,
      taluka: item.taluka,
      normal_copies: item.normal_copies,
      sponsor_copies: item.sponsor_copies,
      complimentary_copies: item.complimentary_copies,
      jyda: item.jyda,
      total_book_copies: item.row_total,
      distribution_mode: item.DistributionMode,
      sub_distribution_mode: item.SubDistMode
    }));

    this.service.saveHandDeliveryData(payload).subscribe({
      next: () => alert('Saved Successfully'),
      error: err => console.error(err)
    });
  }

  // ================= PRINT =================
  printPage(): void {
    const printContent = document.getElementById('print-section');
    if (!printContent) return;

    // copy live ngModel value into the "value" ATTRIBUTE so it survives innerHTML serialization
    const numberInputs = printContent.querySelectorAll('input[type="number"]');
    numberInputs.forEach((input: any) => {
      input.setAttribute('value', input.value ?? '');
    });

    const printWindow = window.open('', '_blank', 'width=1200,height=800');
    if (!printWindow) return;

    printWindow.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            @page {
              size: A3 landscape;
              margin: 10mm;
            }

            * {
              box-sizing: border-box;
              font-family: Arial, sans-serif;
            }

            body {
              margin: 0;
              padding: 0;
            }

            .row {
              display: flex;
              width: 100%;
            }

            .col {
              padding: 4px;
              border: 1px solid #000;
              font-size: 12px;
              word-break: break-word;
            }

            .col-1 { flex: 1; }
            .col-2 { flex: 2; }
            .col-3 { flex: 3; }
            .col-6 { flex: 6; }

            .text-center { text-align: center; }
            .text-end { text-align: right; }
            .text-start { text-align: left; }

            /* Center book name across full row width, keep date pinned right */
            .header {
              position: relative;
              display: flex;
              align-items: center;
              margin-bottom: 8px;
            }

            .header .col-6 {
              flex: 1 1 auto;
              text-align: center;
            }

            .header .col-3 {
              position: absolute;
              right: 0;
            }

            .table-header {
              font-weight: bold;
              background: #eee;
            }

            .total-row {
              font-weight: bold;
              background: #f5f5f5;
            }

            input[type="checkbox"] {
              transform: scale(0.9);
            }

            input[type="number"] {
              width: 100%;
              border: none;
              text-align: center;
              font-size: 12px;
            }

            .noPrint {
              display: none !important;
            }

            hr {
              border: 0;
              border-top: 1px solid #000;
              margin: 6px 0;
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);

    this.removeActionColumn(printWindow);

    // Convert number input to plain text for printing
    printWindow.document.querySelectorAll('input[type="number"]').forEach((input: any) => {
      const span = printWindow.document.createElement('span');
      span.textContent = input.getAttribute('value') || '0';
      input.parentNode.replaceChild(span, input);
    });

    // Remove Save/Print/Close buttons
    printWindow.document.querySelectorAll('button').forEach((btn: any) => btn.remove());

    printWindow.document.close();

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 300);
  }

  private removeActionColumn(printWindow: Window): void {
    const doc = printWindow.document;

    const headerRow = doc.querySelector('.table-header');
    if (headerRow) {
      const cols = headerRow.querySelectorAll('.col');
      if (cols.length) cols[cols.length - 1].remove();
    }

    doc.querySelectorAll('.table-row').forEach((row: any) => {
      const cols = row.querySelectorAll('.col');
      if (cols.length) cols[cols.length - 1].remove();
    });

    const totalRow = doc.querySelector('.total-row');
    if (totalRow) {
      const cols = totalRow.querySelectorAll('.col');
      if (cols.length) cols[cols.length - 1].remove();
    }
  }

  close(): void {
    this.dialog.closeAll();
  }
}